
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
import { getMenuItems } from "@/service/menuItems.service";
import { MenuItem } from "@/types/menuItem.type";

export default defineComponent({
  props: {
    menuItemsOld: {
      type: Object as () => MenuItem[],
      required: true,
    },
  },
  data() {
    return {
      menuItems: [] as MenuItem[],
      menuItemsSelected: [] as MenuItem[],
      selectedItemsId: [] as number[],
    };
  },
  methods: {
    saveItemSelect() {
      for (const item of this.menuItems) {
        if (item.id && this.selectedItemsId.includes(item.id)) {
          this.menuItemsSelected.push(item);
        }
      }
      return this.menuItemsSelected;
    },
  },
  async mounted() {
    let menuList = await getMenuItems();

    this.menuItems = menuList;
    if (this.menuItemsOld && this.menuItemsOld.length > 0) {
      this.menuItemsOld.forEach((item) =>
        this.selectedItemsId.push(item.id !== undefined ? item.id : 100000)
      );
    } else {
      this.selectedItemsId = [1, 2, 3, 4, 5];
    }
  },
});
